import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { AppService } from '@App';
import { IConfigService } from 'app/config/iconfigservice';
import { BaseService } from './base.service';
import { UpdateUserStatusDto, UpdateUserAvailableDto, teamRequest } from '@Models';
import { Observable } from 'rxjs';
import { UpdateAccountDistributionRequest, UpdateUserAccountAccessRequest } from '@App/manage-users/models/update-user-account-access-request.interface';

@Injectable({
    providedIn: 'root'
})
export class UserAdminService extends BaseService {

    publicApiBaseUrl: string;
    private sidenav: MatSidenav;

    constructor(public appService: AppService, public configService: IConfigService,
        public httpClient: HttpClient) {
        super(appService, configService, httpClient);
        this.publicApiBaseUrl = this.configService.getConfiguration().publicApiUrl;
    }

    getAllUsers() {
        return super.getData<any>(`${this.publicApiBaseUrl}user/all`);
    }
    getUser(id, hideWaiting = false) {
        return super.getData<any>(`${this.publicApiBaseUrl}user/${id}`, null, hideWaiting);
    }

    createUser(user) {
        return super.postData(`${this.publicApiBaseUrl}user`, [user]);
    }

    editUser(user) {
        return super.putData(`${this.publicApiBaseUrl}user`, [user]);
    }

    editUserProfile(user, hasWaiting = false) {
        return super.putData(`${this.publicApiBaseUrl}user/profile`, user, null, hasWaiting);
    }
    
    updateUserAccountAccess(request: UpdateUserAccountAccessRequest, hideWaiting = false) {
        return super.patchData(`${this.publicApiBaseUrl}user/update-account-access`, request, null, hideWaiting);
    }

    updateAccountDistribution(request: UpdateAccountDistributionRequest, hideWaiting = false) {
        return super.patchData(`${this.publicApiBaseUrl}user/update-account-distribution`, request, null, hideWaiting);
    }

    updateUserStatus(request: UpdateUserStatusDto): Observable<UpdateUserStatusDto[]> {
        return super.patchData(`${this.publicApiBaseUrl}user/status`, [request]);
    }

    updateUserAvailability(request: UpdateUserAvailableDto, hideWaiting = false) {
        return super.patchData(`${this.publicApiBaseUrl}user/available`, request, null, hideWaiting);
    }

    getUserAvailability(id, hideWaiting = false) {
        return super.getData<any>(`${this.publicApiBaseUrl}user/${id}/available`, null, hideWaiting);
    }

    getUserUnavailabilitySchedule(id: string, hideWaiting = false) {
        return super.getData<any>(`${this.publicApiBaseUrl}user/${id}/unavailablility-schedule`, null, hideWaiting);
    }

    getActiveCurrentUserUnavailabilitySchedule(id: string, hideWaiting = false) {
        return super.getData<any>(`${this.publicApiBaseUrl}user/${id}/current-unavailablility-schedule`, null, hideWaiting);
    }

    upsertUserUnavailabilitySchedule(id: string, payload:any[], hideWaiting = false) {
        return super.postData<any>(`${this.publicApiBaseUrl}user/${id}/upsert-unavailablility-schedule`, payload);
    }
    
    getUserActivity(id: string, hideWaiting = false) {
        return super.getData<any>(`${this.publicApiBaseUrl}user/${id}/user-activity`, null, hideWaiting);
    }

    postTeamCreation(payload: teamRequest, hideWaiting = false) {
        return super.postData<any>(`${this.publicApiBaseUrl}global/teams`, payload);
    }

    getAllTeams(includeAllTeams = false) {
        return super.getData<any>(`${this.publicApiBaseUrl}global/teams/all?includeAllTeams=${includeAllTeams}`);
    }

    getCaseHistory() {
        return super.getData<any>(`${this.publicApiBaseUrl}user/case-history`);
    }

    getFeatureToggles(hideWaiting = false) {
        return super.getData<any>(`${this.publicApiBaseUrl}global/FeatureFlags`, null, hideWaiting);
    }

    public setSidenav(sidenav: MatSidenav) {
        this.sidenav = sidenav;
    }

    public open() {
        return this.sidenav.open();
    }

    public close() {
        return this.sidenav.close();
    }

    public toggle(): void {
        this.sidenav.toggle();
    }
}
